import {FormSelectOptionsT} from '@/lib/types/form.types';

export const productStrains: FormSelectOptionsT[] = [
  {value: 'sativa', label: 'Sativa'},
  {value: 'indica', label: 'Indica'},
  {value: 'hybrid', label: 'Hybrid'},
];
